import { fromEvent } from 'rxjs';
import {
  visibilityIconSvgElement,
  visibilityOffIconSvgElement
} from '../constants/svgIcons';
import formatPhoneNumber from '../utils/formatPhoneNumber';

export default class ContactPhone {
  number = null;

  isNumberVisible = false;

  constructor(rootComponent) {
    this.visibilityIconSvgElement =
      visibilityIconSvgElement.cloneNode(true).outerHTML;
    this.visibilityOffIconSvgElement =
      visibilityOffIconSvgElement.cloneNode(true).outerHTML;

    // if (this.specData.salesNumber) {
    //   this.number = this.specData.salesNumber;
    // }

    this.phoneNumber$ = rootComponent.specDetails$?.subscribe({
      next: details => {
        this.number = details.SalesPhone;
        this.updatePhoneNumber();
      }
    });

    // Delegating to the dialog click event
    fromEvent(rootComponent.dialogElement, 'click').subscribe(e => {
      const button = document.querySelector(
        '[data-self-guided-tour-phone-toggle]'
      );
      if (button && e.target.closest('button') === button) {
        this.togglePhoneNumberVisibility();
      }
    });
  }

  togglePhoneNumberVisibility() {
    this.isNumberVisible = !this.isNumberVisible;
    const button = document.querySelector(
      '[data-self-guided-tour-phone-toggle]'
    );
    if (button) {
      button.innerHTML = this.isNumberVisible
        ? this.visibilityOffIconSvgElement
        : this.visibilityIconSvgElement;
      button.setAttribute('aria-label', this.isNumberVisible ? 'Hide' : 'Show');
    }
    this.updatePhoneNumber();
  }

  getPhoneNumber() {
    if (!this.number || !this.isNumberVisible) {
      const prefix = this.number ? this.number.slice(0, 3) : '***';
      return `${prefix}-***-****`;
    }
    return formatPhoneNumber(this.number);
  }

  updatePhoneNumber() {
    const phoneElement = document.querySelector(
      '[data-self-guided-tour-phone]'
    );
    if (phoneElement) {
      phoneElement.innerHTML = this.getPhoneNumber();
    }
  }

  render() {
    return `
      <p class="nhs-u-flex-row nhs-u-gap--300 nhs-o-typography--sans-body-1-small-book nhs-u-margin--top-500 nhs-mq-display--none-large-max">
        <span class="nhs-u-color--black-1000">Phone:</span>
        <span class="nhs-u-color--black-900" data-self-guided-tour-phone>
          ${this.getPhoneNumber()}
        </span>
        <button type="button" data-self-guided-tour-phone-toggle class="nhs-c-button--hide nhs-c-button--phone__visible" aria-label="Show/Hide">${
          this.visibilityIconSvgElement
        }</button>
      </p>`;
  }
}
